module.exports = (function ($) {
    /**
     * NeighborhoodFeaturesMap constructor
     * 
     * @param {Element} mapElement  
     */
    const NeighborhoodFeaturesMap = function (mapElement) {
        this.mapCenterLat = $(mapElement).data('center-lat');
        this.mapCenterLng = $(mapElement).data('center-lng');
        this.initialCenter = new google.maps.LatLng(this.mapCenterLat, this.mapCenterLng);
        this.initialZoom = 12;
        this.maxZoom = 18;
        this.mapElement = mapElement;
        this.map = null;
        this.neighborhoodMarkers = [];
        this.infoWindows = [];
        this.mapContainClass = 'neighborhood-map-embed__map';
        this.mapListContain = document.querySelector('ul.map-categories');
        this.neighborhoodPin = $(mapElement).data('neighborhood-pin');

        this.icons = {
            // Nieghborhood
            neighborhood: new google.maps.MarkerImage(
                site_data.THEME_URL + '/img/map-pins/' + this.neighborhoodPin,
                new google.maps.Size(34, 55), //size
                new google.maps.Point(0, 0), //origin
                new google.maps.Point(17, 55), //anchor
                new google.maps.Size(34, 55) //scaled size
            ),
            // Dining
            dining: new google.maps.MarkerImage(
                site_data.THEME_URL + '/img/map-pins/dining_pin.svg',
                new google.maps.Size(34, 55), //size
                new google.maps.Point(0, 0), //origin
                new google.maps.Point(17, 55), //anchor
                new google.maps.Size(34, 55) //scaled size
            ),
            // Entertainment
            entertainment: new google.maps.MarkerImage(
                site_data.THEME_URL + '/img/map-pins/entertainment_pin.svg',
                new google.maps.Size(34, 55), //size
                new google.maps.Point(0, 0), //origin
                new google.maps.Point(17, 55), //anchor
                new google.maps.Size(34, 55) //scaled size
            ),
            // Shopping and Banks
            shopping_and_banks: new google.maps.MarkerImage(
                site_data.THEME_URL + '/img/map-pins/shopping_and_banks_pin.svg',
                new google.maps.Size(34, 55), //size
                new google.maps.Point(0, 0), //origin
                new google.maps.Point(17, 55), //anchor
                new google.maps.Size(34, 55) //scaled size
            ),
            // Healtchare and Wellness
            healthcare_and_wellness: new google.maps.MarkerImage(
                site_data.THEME_URL + '/img/map-pins/healthcare_and_wellness_pin.svg',
                new google.maps.Size(34, 55), //size
                new google.maps.Point(0, 0), //origin
                new google.maps.Point(17, 55), //anchor
                new google.maps.Size(34, 55) //scaled size
            ),
            // Outdoor Recreation
            outdoor_recreation: new google.maps.MarkerImage(
                site_data.THEME_URL + '/img/map-pins/outdoor_recreation_pin.svg',
                new google.maps.Size(34, 55), //size
                new google.maps.Point(0, 0), //origin
                new google.maps.Point(17, 55), //anchor
                new google.maps.Size(34, 55) //scaled size
            ),
            
        };
    };

    /**
     * Initializes the Google map on the page, adds initial markers,
     * and sets up event handlers for various user interactions to
     * update the list of neighborhood features
     * 
     * @param {boolean} controls If map controls should be displayed
     */
    NeighborhoodFeaturesMap.prototype.initMap = function (controls) {
        const self = this;
        // Map arguments
        const args = {
            zoom: this.initialZoom,
            maxZoom: this.maxZoom,
            center: this.initialCenter,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            rotateControl: false,
            fullscreenControl: false,
            streetViewControl: false,
            disableDefaultUI: controls === false ? true : false,
            styles: this.mapStyles
        };

        // Create map and store it for future reference
        self.map = new google.maps.Map(this.mapElement, args);

        // Get initial markers
        self.generateMarkers(true);

        // Generate category list
        self.generateListItems();

        // When user pans map, change map center
        self.map.addListener('idle', () => {
            const mapCenter = self.map.getCenter();
            if (mapCenter.lat() !== self.mapCenterLat || mapCenter.lng() !== self.mapCenterLng) {
                self.setMapCenterCoords(mapCenter.lat(), mapCenter.lng());
            }
        });

    };

    /**
     * Removes all markers currently displayed on the map.
     */
    NeighborhoodFeaturesMap.prototype.removeMarkers = function () {
        this.neighborhoodMarkers.forEach(marker => {
            marker.setMap(null);
        });
        this.neighborhoodMarkers = [];
    };

    /**
     * Adds markers to the map based on markup in the neighborhood features list.
     * Optionally extends the bounds of the map to fit all markers.
     * 
     * @param {boolean} initialLoad If this is the initial map load, when the
     *                              bounds should extend to contain all markers
     */
    NeighborhoodFeaturesMap.prototype.generateMarkers = function (initialLoad = false) {
        const self = this;
        const $markers = $('.map-marker');
        const bounds = new google.maps.LatLngBounds();

        //loop through the markers to set them
        $markers.each(function (index, element) {

            const $loc = $(this);
            const locId = $(this).data('id');
            const lat = $(this).data('lat');
            const lng = $(this).data('lng');
            const addr = $(this).data('address');

            // Marker coordinates
            const latlng = new google.maps.LatLng(lat, lng);

            // create marker
            var marker = new google.maps.Marker({
                position: latlng,
                map: self.map,
                optimized: false,
                icon: self.icons[$(this).data('category')],
                category: $(this).data('category') ?? null,
                infoWindowOpen: false
                // No animation for the neighborhood features map
                // animation: google.maps.Animation.DROP
            });

            if (initialLoad) {
                self.map.setCenter({ lat: self.mapCenterLat, lng: self.mapCenterLng });

                bounds.extend(marker.position);
                self.map.fitBounds(bounds);
            }

            // Only add click action and infowindow if this marker has popup content
            const popupContent = $(this).find('.map-marker-popup');
            if (popupContent.length > 0) {

                const infowindow = new google.maps.InfoWindow({
                    content: popupContent[0],
                    ariaLabel: addr,
                });

                self.infoWindows.push(infowindow);

                // MARKER CLICK
                marker.addListener('click', function () {

                    // close all the other windows
                    self.infoWindows.forEach(infoWindow => {
                        infoWindow.close();
                    })
                    
                    // Info window doesn't have a flag so we have to keep track of it ourselves
                    // Check if the window is open, and if so close it, and vice versa
                    marker.infoWindowOpen
                        ? infowindow.close()
                        : infowindow.open({
                            anchor: marker,
                            map: self.map,
                        });

                    marker.infoWindowOpen = !marker.infoWindowOpen;

                    // Close the window if the user clicks something else that's not the window or marker
                    google.maps.event.addListener(self.map, 'click', function() {

                        marker.infoWindowOpen = false;
                        infowindow.close();

                    });
                });
            }

            //add marker to markers array
            self.neighborhoodMarkers.push(marker);

        }); //endfor each marker
    };

    /**
     * Sets the click action for the neighborhood map list items to filter pins.
     */
    NeighborhoodFeaturesMap.prototype.generateListItems = function () {
        const self = this;
        const categories = $('.neighborhood-map-list-item');

        categories.each(function (index, category) {

            category.addEventListener('click', function () {

                categories.removeClass('active');
                this.classList.add('active');

                self.neighborhoodMarkers.forEach(marker => {

                    // The category is view all
                    // The category of the filter is the same as the category of the marker
                    // The category of the marker is neighborhood, which is always visibile
                    if ($(this).data('category') === 'view_all' || marker.category === $(this).data('category') || marker.category === 'neighborhood') {
                        
                        // Sets the map for the marker, adding the marker back to the map (not just setting it visible)
                        marker.setMap(self.map);
                    } else {
                        // Sets the map to null, removing the marker from the map (not just setting it invisible)
                        marker.setMap(null);
                    }
                })

            });
        });
    }

    /**
     * Sets the map center lat/lng.
     * 
     * @param {number} lat 
     * @param {number} lng 
     */
    NeighborhoodFeaturesMap.prototype.setMapCenterCoords = function (lat, lng) {
        this.mapCenterLat = lat;
        this.mapCenterLng = lng;
    };

    // Return our NeighborhoodFeaturesMap function so we can use it outside the current scope
    return NeighborhoodFeaturesMap;

})(jQuery);
